import React, { useState, useEffect } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import { Footer } from "../../Footer";
import { Button, Col, Row, Table } from "react-bootstrap";
import {
  SecondaryMarketAnnouncement,
  SecondaryMarketAnnouncementData,
} from "../../redux/auth-reducer/auth-service";
import * as icons from "react-bootstrap-icons";
import dayjs from "dayjs";

export const Secondary_Market_Announcement = () => {
  const [data, setData] = useState();
  const [searchText, setSearchText] = useState("");
  const [announcements, setAnnouncements] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  function sidebarfun() {
    setData(!data);
  }

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  const columns = [
    {
      name: <strong>Auction Name</strong>,
      selector: (row) => row.auctionName,
      sortable: true,
    },
    {
      name: <strong>Team Name</strong>,
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: <strong>Team Owner Name</strong>,
      selector: (row) => row.teamOwnerName,
      sortable: true,
    },
    {
      name: <strong>Bid Amount</strong>,
      selector: (row) => row.bidAmount,
      sortable: true,
    },
    {
      name: <strong>Level</strong>,
      selector: (row) => row.level,
      sortable: true,
    },
    {
      name: <strong> Ownership Percentage</strong>,
      selector: (row) => row.ownerShipPercentage,
      sortable: true,
    },
    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
    },

    {
      name: <strong>End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
    },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const uniqueAuctionIds = new Set();

  // useEffect(() => {
  //     const AnnouncementMsgFunc = async () => {
  //         await SecondaryMarketAnnouncement().then((response) => {
  //             setAnnouncements(response?.data?.data?.dataList);
  //         });
  //     };
  //     AnnouncementMsgFunc();
  // }, []);

  const AnnouncementMsgFunc = async (data) => {
    try {
      const response = await SecondaryMarketAnnouncementData(data); // Call your API function
      if (response?.data) {
        setAnnouncements(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    AnnouncementMsgFunc(data); // Fetch data when currentPage changes
  }, [currentPage]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    AnnouncementMsgFunc(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const filteredDataList = announcements?.filter((item) => {
    if (!uniqueAuctionIds.has(item?.auctionId)) {
      return true;
    }
    return false;
  });

  const filteredData = searchText
    ? filteredDataList.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.managerName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.sportName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : filteredDataList;

  const filterData = (auctionId) => {
    return announcements.filter((item) => item.auctionId === auctionId);
  };

  const ExpandedComponents = ({ data }) => {
    const relatedData = filterData(data.auctionId);

    return (
      <div>
        <h4>Details for {data.auctionName}</h4>
        <Table striped bordered hover size="sm" className="text-center">
          <thead>
            <tr>
              <th>Auction Name</th>
              <th>Team Name</th>
              <th>Team Owner Name</th>
              <th>Bid Amount</th>

              <th>Ownership Percentage</th>
              <th>Start Date & Time</th>

              <th>End Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {relatedData.map((item) => {
              return (
                <tr key={item?.auctionName}>
                  <td>{item?.auctionName}</td>
                  <td>{item?.teamName}</td>
                  <td>{item?.teamOwnerName}</td>
                  <td>{item?.bidAmount}</td>

                  <td>{item?.ownerShipPercentage}</td>
                  <td>
                    {dayjs(item?.startDate + "Z").format(
                      "MM/DD/YYYY hh:mm:ss A"
                    )}
                  </td>

                  <td>
                    {dayjs(item?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Secondary Market Result</h1>
            </Col>
          </Row>

          <div className="group_data_table sec-announcement">
            {/* <div className="search-input d-flex align-items-center">
                               <input
                                type="text"
                                className="form-control mb-3 mt-3"
                                placeholder="Search..."
                                value={searchText}
                                onChange={handleSearch}
                            />
                        </div> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>

            {/* <DataTable
                            title="Announcement"
                            columns={columns}
                            data={filteredData}
                            pagination
                            expandableRows
                            expandableRowExpanded={(row) => row.defaultExpanded}
                            expandableRowsComponent={ExpandedComponents}
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            paginationTotalRows={filteredData?.length}
                        /> */}
            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                expandableRows
                expandableRowExpanded={(row) => row.defaultExpanded}
                expandableRowsComponent={ExpandedComponents}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
